import { logPrefix } from '../sdk/constants';

export const ONGOING_FETCHES = new Map<string, Promise<any>>();

/**
 * Keeps track of fetch calls to avoid calling it many times simultaneously
 *
 * @hidden
 *
 * @param {string} url - URL To call
 * @param {*} [options={}] - window.fetch options
 * @param {string} methodName - Name of the method being called (to keep track of it)
 * @returns
 */
export default function SingletonFetch(
  url: string,
  options = {},
  methodName: string
): Promise<any> {

  if (ONGOING_FETCHES.has(methodName)) {
    console.info(`${logPrefix} ${methodName} cannot be called until the previous to ${methodName} completes`);
    return ONGOING_FETCHES.get(methodName) as Promise<any>;
  }

  const fetchPromise = fetch(url, options)
    .finally(() => {
      ONGOING_FETCHES.delete(methodName);
    });
    
  ONGOING_FETCHES.set(methodName, fetchPromise);

  return fetchPromise;
}
